import { useEffect } from 'react';
import { addHold } from './gateStore';

/** While `active`, the auth gate stays up (the thing behind it is still loading). Costs nothing when there is no gate. */
export function useGateHold(active: boolean): void {
  useEffect(() => {
    if (!active) return;
    return addHold();
  }, [active]);
}
